(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/ErrorResponse500', '../model/ClonePackage', '../model/Error', '../model/BlendedPackage', '../model/Files', '../model/ConflictFile', '../model/ErrorResponse400', '../model/UpdateDraft', '../model/HyperLinkDraft', '../model/Documents', '../model/UpdateLocal'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ErrorResponse500'), require('../model/ClonePackage'), require('../model/Error'), require('../model/BlendedPackage'), require('../model/Files'), require('../model/ConflictFile'), require('../model/ErrorResponse400'), require('../model/UpdateDraft'), require('../model/HyperLinkDraft'), require('../model/Documents'), require('../model/UpdateLocal'));
  } else {
    // Browser globals (root is window)
    if (!root.Swagger) {
      root.Swagger = {};
    }
    root.Swagger.LocalApi = factory(root.Swagger.ApiClient, root.Swagger.ErrorResponse500, root.Swagger.ClonePackage, root.Swagger.Error, root.Swagger.BlendedPackage, root.Swagger.Files, root.Swagger.ConflictFile, root.Swagger.ErrorResponse400, root.Swagger.UpdateDraft, root.Swagger.HyperLinkDraft, root.Swagger.Documents, root.Swagger.UpdateLocal);
  }
}(this, function(ApiClient, ErrorResponse500, ClonePackage, Error, BlendedPackage, Files, ConflictFile, ErrorResponse400, UpdateDraft, HyperLinkDraft, Documents, UpdateLocal) {
  'use strict';

  /**
   * Local service.
   * @module api/LocalApi
   * @version 1.0.0
   */

  /**
   * Constructs a new LocalApi. 
   * @alias module:api/LocalApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the cloneFromCanonical operation.
     * @callback module:api/LocalApi~cloneFromCanonicalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * do a full replacement of the first package
     * checks previous_package_hash, also will pull down the version to be cloned, if necessary, from the hub.  It only tries to install or pull if the local copies are not there; error on timeout only in that case
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/ClonePackage} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~cloneFromCanonicalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.cloneFromCanonical = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling cloneFromCanonical";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling cloneFromCanonical";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling cloneFromCanonical";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling cloneFromCanonical";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling cloneFromCanonical";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cloneFromCanonical";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/canonical/documents/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cloneFromDraft operation.
     * @callback module:api/LocalApi~cloneFromDraftCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update or Create first package with second
     * This would be unsafe, however, unless &#39;force&#39; remains default false, and &#39;previous_package_hash&#39; is &#39;&#39; (the empty string).
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/ClonePackage} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~cloneFromDraftCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.cloneFromDraft = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling cloneFromDraft";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling cloneFromDraft";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling cloneFromDraft";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling cloneFromDraft";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling cloneFromDraft";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cloneFromDraft";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/draft/documents/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cloneFromLocal operation.
     * @callback module:api/LocalApi~cloneFromLocalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * do a full replacement of the first package
     * checks previous_package_hash, also will pull down the version to be cloned, if necessary, from the hub.  It only tries to install or pull if the local copies are not there; error on timeout only in that case
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/ClonePackage} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~cloneFromLocalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.cloneFromLocal = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling cloneFromLocal";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling cloneFromLocal";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling cloneFromLocal";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling cloneFromLocal";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling cloneFromLocal";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cloneFromLocal";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/local/documents/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the cloneFromVersion operation.
     * @callback module:api/LocalApi~cloneFromVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * do a full replacement of the first package
     * checks previous_package_hash, also will pull down the version to be cloned, if necessary, from the hub.  It only tries to install or pull if the local copies are not there; error on timeout only in that case
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} label version label value.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/ClonePackage} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~cloneFromVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.cloneFromVersion = function(accountSlug1, slug1, accountSlug2, slug2, label, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling cloneFromVersion";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling cloneFromVersion";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling cloneFromVersion";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling cloneFromVersion";
      }

      // verify the required parameter 'label' is set
      if (label == undefined || label == null) {
        throw "Missing the required parameter 'label' when calling cloneFromVersion";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling cloneFromVersion";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling cloneFromVersion";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2,
        'label': label
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/versions/{label}/documents/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareFileWithCanonical operation.
     * @callback module:api/LocalApi~compareFileWithCanonicalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Files} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return both files so that a comparison could be done in the GUI
     *  return both files so that a comparison could be done in the GUI
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} document File name 
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~compareFileWithCanonicalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Files}
     */
    this.compareFileWithCanonical = function(accountSlug1, slug1, accountSlug2, slug2, document, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareFileWithCanonical";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareFileWithCanonical";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareFileWithCanonical";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareFileWithCanonical";
      }

      // verify the required parameter 'document' is set
      if (document == undefined || document == null) {
        throw "Missing the required parameter 'document' when calling compareFileWithCanonical";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareFileWithCanonical";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2,
        'document': document
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Files;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/canonical/documents/{document}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareFileWithDraft operation.
     * @callback module:api/LocalApi~compareFileWithDraftCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Files} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return both files so that a comparison could be done in the GUI
     *  return both files so that a comparison could be done in the GUI
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} document File name 
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~compareFileWithDraftCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Files}
     */
    this.compareFileWithDraft = function(accountSlug1, slug1, accountSlug2, slug2, document, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareFileWithDraft";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareFileWithDraft";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareFileWithDraft";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareFileWithDraft";
      }

      // verify the required parameter 'document' is set
      if (document == undefined || document == null) {
        throw "Missing the required parameter 'document' when calling compareFileWithDraft";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareFileWithDraft";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2,
        'document': document
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Files;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/draft/documents/{document}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareFileWithLocal operation.
     * @callback module:api/LocalApi~compareFileWithLocalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Files} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return both files so that a comparison could be done in the GUI
     *  return both files so that a comparison could be done in the GUI
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} document File name 
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~compareFileWithLocalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Files}
     */
    this.compareFileWithLocal = function(accountSlug1, slug1, accountSlug2, slug2, document, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareFileWithLocal";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareFileWithLocal";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareFileWithLocal";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareFileWithLocal";
      }

      // verify the required parameter 'document' is set
      if (document == undefined || document == null) {
        throw "Missing the required parameter 'document' when calling compareFileWithLocal";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareFileWithLocal";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2,
        'document': document
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Files;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/local/documents/{document}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareFileWithVersion operation.
     * @callback module:api/LocalApi~compareFileWithVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Files} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return both files so that a comparison could be done in the GUI
     *  return both files so that a comparison could be done in the GUI
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} label version label value.
     * @param {String} document File name 
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~compareFileWithVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Files}
     */
    this.compareFileWithVersion = function(accountSlug1, slug1, accountSlug2, slug2, label, document, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareFileWithVersion";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareFileWithVersion";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareFileWithVersion";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareFileWithVersion";
      }

      // verify the required parameter 'label' is set
      if (label == undefined || label == null) {
        throw "Missing the required parameter 'label' when calling compareFileWithVersion";
      }

      // verify the required parameter 'document' is set
      if (document == undefined || document == null) {
        throw "Missing the required parameter 'document' when calling compareFileWithVersion";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareFileWithVersion";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2,
        'label': label,
        'document': document
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Files;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/versions/{label}/documents/{document}/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareWithCanonical operation.
     * @callback module:api/LocalApi~compareWithCanonicalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConflictFile} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * compare the packages, and return a list of the files that are different.
     * 
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~compareWithCanonicalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ConflictFile}
     */
    this.compareWithCanonical = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareWithCanonical";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareWithCanonical";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareWithCanonical";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareWithCanonical";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareWithCanonical";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConflictFile;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/canonical/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareWithDraft operation.
     * @callback module:api/LocalApi~compareWithDraftCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConflictFile} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * compare the packages, and return a list of the files that are different.
     * 
     * @param {String} sessionkey value used to manage hub user session.
     * @param {String} accountSlug1 first account slug.
     * @param {String} slug1 first package slug.
     * @param {String} accountSlug2 second account slug.
     * @param {String} slug2 second package slug.
     * @param {module:api/LocalApi~compareWithDraftCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ConflictFile}
     */
    this.compareWithDraft = function(sessionkey, accountSlug1, slug1, accountSlug2, slug2, callback) {
      var postBody = null;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareWithDraft";
      }

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareWithDraft";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareWithDraft";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareWithDraft";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareWithDraft";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['text/plain'];
      var accepts = ['application/json'];
      var returnType = ConflictFile;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/draft/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareWithLocal operation.
     * @callback module:api/LocalApi~compareWithLocalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConflictFile} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * compare the packages, and return a list of the files that are different.
     * 
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~compareWithLocalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ConflictFile}
     */
    this.compareWithLocal = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareWithLocal";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareWithLocal";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareWithLocal";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareWithLocal";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareWithLocal";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConflictFile;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/local/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the compareWithVersion operation.
     * @callback module:api/LocalApi~compareWithVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ConflictFile} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * compare the packages, and return a list of the files that are different.
     * 
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} label version label value.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~compareWithVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ConflictFile}
     */
    this.compareWithVersion = function(accountSlug1, slug1, accountSlug2, slug2, label, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling compareWithVersion";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling compareWithVersion";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling compareWithVersion";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling compareWithVersion";
      }

      // verify the required parameter 'label' is set
      if (label == undefined || label == null) {
        throw "Missing the required parameter 'label' when calling compareWithVersion";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling compareWithVersion";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2,
        'label': label
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ConflictFile;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/versions/{label}/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the localCreate operation.
     * @callback module:api/LocalApi~localCreateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Package.
     * 
     * @param {String} sessionkey value used to manage hub user session.
     * @param {String} accountSlug account slug
     * @param {String} slug package slug.
     * @param {module:model/UpdateDraft} body Request data used to merge package.
     * @param {module:api/LocalApi~localCreateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.localCreate = function(sessionkey, accountSlug, slug, body, callback) {
      var postBody = body;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling localCreate";
      }

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling localCreate";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling localCreate";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling localCreate";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/local/documents/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the localDelete operation.
     * @callback module:api/LocalApi~localDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete the local package
     * package hash mismatch error at the end (not a timeout, but an actual conflict with previous_package_hash on hub), then the GUI will initiate this delete, because the GUI is managing the whole control flow.
     * @param {String} accountSlug account slug used to uniquely identify a package.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/UpdateDraft} body request data used to update package.
     * @param {module:api/LocalApi~localDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.localDelete = function(accountSlug, slug, sessionkey, body, callback) {
      var postBody = body;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling localDelete";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling localDelete";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling localDelete";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling localDelete";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/local/', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the localDetails operation.
     * @callback module:api/LocalApi~localDetailsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/HyperLinkDraft} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return package local meta data
     * @param {String} accountSlug account slug used to uniquely identify a package.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~localDetailsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/HyperLinkDraft}
     */
    this.localDetails = function(accountSlug, slug, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling localDetails";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling localDetails";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling localDetails";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = HyperLinkDraft;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/local/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the localDownload operation.
     * @callback module:api/LocalApi~localDownloadCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Documents} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get The package from local if not found do weak pull
     * hash-only pull also will pe performed in same. that confirms that neither local nor draft exist
     * @param {String} accountSlug account slug used to uniquely identify a package.
     * @param {String} slug package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {Object} opts Optional parameters
     * @param {String} opts.asHash for hash only pull
     * @param {module:api/LocalApi~localDownloadCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Documents}
     */
    this.localDownload = function(accountSlug, slug, sessionkey, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling localDownload";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling localDownload";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling localDownload";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
        'as_hash': opts['asHash']
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Documents;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/local/documents/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the localDownloadFile operation.
     * @callback module:api/LocalApi~localDownloadFileCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * return the file data from hub, and download to host if package is missing
     * @param {String} accountSlug slug of account
     * @param {String} slug slug of package to return.
     * @param {String} name name of the file
     * @param {String} sessionkey value used to manage user session.
     * @param {module:api/LocalApi~localDownloadFileCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.localDownloadFile = function(accountSlug, slug, name, sessionkey, callback) {
      var postBody = null;

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling localDownloadFile";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling localDownloadFile";
      }

      // verify the required parameter 'name' is set
      if (name == undefined || name == null) {
        throw "Missing the required parameter 'name' when calling localDownloadFile";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling localDownloadFile";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug,
        'name': name
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        'packages/{accountSlug}/{slug}/local/documents/{name}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the localUpdate operation.
     * @callback module:api/LocalApi~localUpdateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update Package.
     * 
     * @param {String} sessionkey value used to manage hub user session.
     * @param {String} accountSlug account slug
     * @param {String} slug package slug.
     * @param {module:model/UpdateDraft} body Request data used to merge package.
     * @param {module:api/LocalApi~localUpdateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.localUpdate = function(sessionkey, accountSlug, slug, body, callback) {
      var postBody = body;

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling localUpdate";
      }

      // verify the required parameter 'accountSlug' is set
      if (accountSlug == undefined || accountSlug == null) {
        throw "Missing the required parameter 'accountSlug' when calling localUpdate";
      }

      // verify the required parameter 'slug' is set
      if (slug == undefined || slug == null) {
        throw "Missing the required parameter 'slug' when calling localUpdate";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling localUpdate";
      }


      var pathParams = {
        'accountSlug': accountSlug,
        'slug': slug
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug}/{slug}/local/documents/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateFromCanonical operation.
     * @callback module:api/LocalApi~updateFromCanonicalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * would do file-specific changes
     * do file-specific changes, pulling the individual files from the second package, and placing them in the same positions in the first.  Deletes would work by specifying a file location that is empty in the second package, but present in the first package.
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/UpdateLocal} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~updateFromCanonicalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.updateFromCanonical = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling updateFromCanonical";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling updateFromCanonical";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling updateFromCanonical";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling updateFromCanonical";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling updateFromCanonical";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateFromCanonical";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/canonical/documents/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateFromDraft operation.
     * @callback module:api/LocalApi~updateFromDraftCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * would do file-specific changes
     * pulling the individual files from the second package, and placing them in the same positions in the first.  Deletes would work by specifying a file location that is empty in the second package, but present in the first package.
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/UpdateLocal} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~updateFromDraftCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.updateFromDraft = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling updateFromDraft";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling updateFromDraft";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling updateFromDraft";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling updateFromDraft";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling updateFromDraft";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateFromDraft";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/draft/documents/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateFromLocal operation.
     * @callback module:api/LocalApi~updateFromLocalCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * would do file-specific changes
     * do file-specific changes, pulling the individual files from the second package, and placing them in the same positions in the first.  Deletes would work by specifying a file location that is empty in the second package, but present in the first package.
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/UpdateLocal} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~updateFromLocalCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.updateFromLocal = function(accountSlug1, slug1, accountSlug2, slug2, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling updateFromLocal";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling updateFromLocal";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling updateFromLocal";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling updateFromLocal";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling updateFromLocal";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateFromLocal";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/local/documents/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateFromVersion operation.
     * @callback module:api/LocalApi~updateFromVersionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BlendedPackage} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * would do file-specific changes
     * do file-specific changes, pulling the individual files from the second package, and placing them in the same positions in the first.  Deletes would work by specifying a file location that is empty in the second package, but present in the first package.
     * @param {String} accountSlug1 accountSlug
     * @param {String} slug1 package slug used to uniquely identify a package.
     * @param {String} accountSlug2 accountSlug
     * @param {String} slug2 package slug used to uniquely identify a package.
     * @param {String} label version label value.
     * @param {String} sessionkey value used to manage user session.
     * @param {module:model/UpdateLocal} body request data used to update package.
     * @param {Object} opts Optional parameters
     * @param {String} opts.force value used to manage user session.
     * @param {module:api/LocalApi~updateFromVersionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/BlendedPackage}
     */
    this.updateFromVersion = function(accountSlug1, slug1, accountSlug2, slug2, label, sessionkey, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'accountSlug1' is set
      if (accountSlug1 == undefined || accountSlug1 == null) {
        throw "Missing the required parameter 'accountSlug1' when calling updateFromVersion";
      }

      // verify the required parameter 'slug1' is set
      if (slug1 == undefined || slug1 == null) {
        throw "Missing the required parameter 'slug1' when calling updateFromVersion";
      }

      // verify the required parameter 'accountSlug2' is set
      if (accountSlug2 == undefined || accountSlug2 == null) {
        throw "Missing the required parameter 'accountSlug2' when calling updateFromVersion";
      }

      // verify the required parameter 'slug2' is set
      if (slug2 == undefined || slug2 == null) {
        throw "Missing the required parameter 'slug2' when calling updateFromVersion";
      }

      // verify the required parameter 'label' is set
      if (label == undefined || label == null) {
        throw "Missing the required parameter 'label' when calling updateFromVersion";
      }

      // verify the required parameter 'sessionkey' is set
      if (sessionkey == undefined || sessionkey == null) {
        throw "Missing the required parameter 'sessionkey' when calling updateFromVersion";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateFromVersion";
      }


      var pathParams = {
        'accountSlug1': accountSlug1,
        'slug1': slug1,
        'accountSlug2': accountSlug2,
        'slug2': slug2,
        'label': label
      };
      var queryParams = {
      };
      var headerParams = {
        'sessionkey': sessionkey,
        'force': opts['force']
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = BlendedPackage;

      return this.apiClient.callApi(
        '/packages/{accountSlug1}/{slug1}/update/{accountSlug2}/{slug2}/versions/{label}/documents/', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));



/*****************
 ** WEBPACK FOOTER
 ** ./~/swagger/src/api/LocalApi.js
 ** module id = 274
 ** module chunks = 0
 **/